import { render, staticRenderFns } from "./InheemsGame.vue?vue&type=template&id=78327a84&"
import script from "./InheemsGame.vue?vue&type=script&lang=js&"
export * from "./InheemsGame.vue?vue&type=script&lang=js&"
import style0 from "./InheemsGame.vue?vue&type=style&index=0&id=78327a84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports